import React, { useContext } from 'react';

import { Route, Switch } from 'react-router-dom';

import { TeamsPageContext } from '../../contexts/teamsPageProvider';
import { REPORTS_ROUTE } from './constants';
import { TeamsReportDetails, TeamsReportsHistory, TeamsReportsProps } from './TeamsReportsPage';

type Props = Omit<TeamsReportsProps, 'companyId' | 'teams'>;

/**
 * /teams/reports and /teams/reports/:requestId inside the Teams module of either app.
 * The detail route is where every notification link lands.
 */
export const TeamsReportsRoute: React.FC<Props> = props => {
  const { selectedCompanyId, teams } = useContext(TeamsPageContext);
  const common = { ...props, companyId: selectedCompanyId, teams: teams ?? [] };

  return (
    <Switch>
      <Route
        exact
        path={`${REPORTS_ROUTE}/:requestId`}
        render={({ match }) => (
          <TeamsReportDetails key={match.params.requestId} requestId={match.params.requestId} {...common} />
        )}
      />
      <Route path={REPORTS_ROUTE} render={() => <TeamsReportsHistory key={selectedCompanyId} {...common} />} />
    </Switch>
  );
};
